$('body').on('click', '.open-payment-menu', function() {
    var $this = $(this);
    var menu = $this.parents('.payment-menu-wrapper');
    
    $('.payment-menu', menu).css({
        top: menu.position().top,
        left: 5 + (menu.position().left + menu.width()) - $('.payment-menu', menu).width()
    });

    menu.addClass('opened');
    closeDropdown($this.parents('.payment-menu-wrapper').attr('data-dropdown'));
    return false;
});

$('body').on('click', '.payments .filters .open-dropdown', function () {
    var $this = $(this);
    var menu = $this.parents('.dropdown-wrapper');

    if (menu.hasClass('opened')) {
        closeDropdown();
        return false;
    }

    menu.addClass('opened');
    closeDropdown($this.parents('.dropdown-wrapper').attr('data-dropdown'));
    return false;
});




$('body').on('click', '.refund-payment-trigger', function () {
    var data = $(this).parents('.payment');
    var action = $('.refund-payment form')
        .attr('data-action')
        .replace('{payment}', data.attr('data-payment'));
    $('.refund-payment form').attr('action', action);

    $('.refund-payment input[name="amount"]').val(data.attr('data-amount'));

    closeDropdown();
    openModal('.refund-payment');
    return false;
});

$('body').on('click', '.resend-payment-invoice-trigger', function () {
    var data = $(this).parents('.payment');
    var action = $('.resend-payment-invoice form').attr('data-action').replace('{payment}', data.attr('data-payment'));
    $('.resend-payment-invoice form').attr('action', action);
    $('.resend-payment-invoice input[name="email"]').val(data.attr('data-email'));

    closeDropdown();
    openModal('.resend-payment-invoice');
    return false;
});

$('body').on('click', '.mark-approved-trigger', function() {
    closeDropdown();
    var $this = $(this);
    loading();
    $.ajax({
        type: 'POST',
        url: $this.attr('href'),
        data: {
            '_method': 'PUT',
            '_token': $('meta[name="csrf-token"]').attr('content')
        },
        dataType: 'json',
        success: function (data) {
            console.log(data);
            unloading();

            if (!data.success) {
                showError('Error', data.message);
                return false;
            }

            closeModal();
            addNotification(data.notification.title, data.notification.message, data.notification.icon);
        },
        error: function (request) {
            console.log(request.responseText);
        }
    });
    
    return false;
});

$('body').on('click', '.edit-payment-trigger', function () {
    var data = $(this).parents('.payment');
    var action = $('.edit-payment form').attr('data-action').replace('{payment}', data.attr('data-payment'));
    $('.edit-payment form').attr('action', action);

    $('.edit-payment [name="first_name"]').val(data.attr('data-first_name'));
    $('.edit-payment [name="last_name"]').val(data.attr('data-last_name'));
    $('.edit-payment [name="street"]').val(data.attr('data-street'));
    $('.edit-payment [name="city"]').val(data.attr('data-city'));
    $('.edit-payment [name="state"]').val(data.attr('data-state'));
    $('.edit-payment [name="zip"]').val(data.attr('data-zip'));
    $('.edit-payment [name="email"]').val(data.attr('data-email'));
    $('.edit-payment [name="phone"]').val(data.attr('data-phone'));
    $('.edit-payment [name="amount"]').val(data.attr('data-amount'));
    $('.edit-payment [name="payment_date"]').val(data.attr('data-payment_date'));
    $('.edit-payment [name="check_number"]').val(data.attr('data-check_number'));
    $('.edit-payment [name="notes"]').val(data.attr('data-notes'));

    closeDropdown();
    openModal('.edit-payment');
    return false;
});

$('body').on('click', '.delete-payment-trigger', function () {
    var data = $(this).parents('.payment');
    var action = $('.delete-payment form').attr('data-action').replace('{payment}', data.attr('data-payment'));
    $('.delete-payment form').attr('action', action);

    closeDropdown();
    openModal('.delete-payment');
    return false;
});

$('body').on('submit', '.edit-payment form, .delete-payment form, .refund-payment form, .resend-payment-invoice form', function () {
    var $this = $(this);
    var fields = $this.serializeArray();
    fields[fields.length] = { name: '_token', value: $('meta[name="csrf-token"]').attr('content') };

    loading();
    $.ajax({
        type: 'POST',
        url: $this.attr('action'),
        data: fields,
        dataType: 'json',
        success: function (data) {
            console.log(data);
            unloading();

            if (!data.success) {
                showError('Error', data.message);
                return false;
            }

            closeModal();
            addNotification(data.notification.title, data.notification.message, data.notification.icon);
        },
        error: function (request) {
            console.log(request.responseText);
        }
    });

    return false;
});


function paymentMethod(data) {
    if (data.is_card) {
        return `<td class="flex-wrapper">
            <div class="flex">
                <figure>
                    <img src="images/icons/${data.card_type ? data.card_type : 'card'}.svg" alt="carrier">
                </figure>
                <p>${data.masked_number} <span>${data.method} - ${data.full_name}</span></p>
            </div>
        </td>`;
    }

    return `<td>${data.method}</td>`;
}

function addPayment(data) {
    if ($('.manage-year-seat[data-year_seat="' + data.year_seat + '"]').length) {
        return true;
    }

    if ($('.manage-owner[data-owner="' + data.owner + '"]').length) {
        return true;
    }

    return false;
}

channel.bind('process-payment', function(data) {
    console.log(data);

    var element;
    if($('.payment[data-payment="'+data.payment+'"]').length) {
        
        element = $('.payment[data-payment="'+data.payment+'"]');
        
        element.attr('data-first_name', data.first_name);
        element.attr('data-last_name', data.last_name);
        element.attr('data-street', data.street);
        element.attr('data-city', data.city);
        element.attr('data-state', data.state);
        element.attr('data-zip', data.zip);
        element.attr('data-email', data.email);
        element.attr('data-amount', data.amount);
        element.attr('data-phone', data.phone);
        element.attr('data-notes', data.notes);
        element.attr('data-check_number', data.check_number);
        element.attr('data-payment_date', data.payment_date);

        element.find('[data-input="owner_name"]').html(data.owner_name);
        element.find('[data-input="owner_heber_name"]').html(data.owner_heber_name);
        element.find('[data-input="seat_seat_number"]').html(data.seat_seat_number);
        element.find('[data-input="saet_old_number"]').html(data.saet_old_number);
        element.find('[data-input="full_name"]').html(data.full_name);
        element.find('[data-input="email"]').html(data.email);
        element.find('[data-input="phone"]').html(data.phone);
        element.find('[data-input="street"]').html(data.street);
        element.find('[data-input="city"]').html(data.city);
        element.find('[data-input="state"]').html(data.state);
        element.find('[data-input="zip"]').html(data.zip);
        element.find('[data-input="amount_parsed"]').html(data.amount_parsed);
        element.find('[data-input="status"]').html(data.status);
        element.find('[data-input="status"]').attr('data-color', data.status_color);
        element.find('[data-input="payment_date_parsed"]').html(data.payment_date_parsed);
        element.find('[data-input="check_number"]').html(data.check_number);
        element.find('[data-input="notes"]').html(data.notes);

        element.find('.menu').html(buttons(data.buttons));
        return;
    }

    if ($('body').attr('data-page') === '1' || addPayment(data)) {
        element = $('<tr>', {
            class: 'payment',
            'data-payment': data.payment,
            'data-first_name': data.first_name,
            'data-last_name': data.last_name,
            'data-street': data.street,
            'data-city': data.city,
            'data-state': data.state,
            'data-zip': data.zip,
            'data-email': data.email,
            'data-amount': data.amount,
            'data-phone': data.phone,
            'data-payment_date': data.payment_date,
            'data-notes': data.notes,
            'data-check_number': data.check_number
        });

        element.append(`<td>
            <p data-input="owner_name">${data.owner_name}</p> 
            <p class="small-text" data-input="owner_hebrew_name">${
                data.owner_hebrew_name
            }</p> 
        </td>

        <td>
            <p data-input="seat_seat_number">${data.seat_seat_number}</p>
            <p class="small-text" data-input="seat_old_number">${
                data.seat_old_number
            }</p>
        </td>

        <td>
            <p data-input="full_name">${data.full_name}</p>
            <p class="small-text">
                <span data-input="email">${data.email}</span> <br>
                <span data-input="phone">${data.phone}</span>
            </p>
        </td>
        
        <td>
            <p data-input="street">${data.street}</p>
            <p class="small-text">
                <span data-input="city">${data.city}</span>,
                <span data-input="state">${data.state}</span>
                <span data-input="zip">${data.zip}</span>
            </p>
        </td>

        <td>
            <p data-input="amount_parsed">${data.amount_parsed}</p>
        </td>

        ${paymentMethod(data)}

        <td>
            <p data-input="notes">${data.notes}</p>
            <p class="small-text" data-input="check_number">${data.check_number}</p>
        </td>

        <td>
            <span class="highlight" data-color="${data.status_color}" data-input="status">
                ${data.status}
            </span>
        </td>

        <td data-input="payment_date_parsed">
            ${data.payment_date_parsed}
        </td>

		<td class="payment-menu-wrapper menu-wrapper" data-dropdown="payment-${data.payment}">
            <a href="" class="icon-more open-payment-menu open-menu"></a>
            <ul class="payment-menu menu">
                ${buttons(data.buttons)}
            </ul>
        </td>`);

        $('.payments tbody').prepend(element);
    }
});

channel.bind('remove-payment', function(data) {
    if($('.payments [data-payment="'+data.payment+'"]').length) {
        $('.payments [data-payment="'+data.payment+'"]').remove();
    }
});